/* eslint-disable react-hooks/exhaustive-deps */
import { useContext } from "react";
import toast from "react-hot-toast";
import { AppContext } from "../../scripts/context";
import CardBody from "./CardBody";
import Style from "./style";

export const ButtonComponent = () => {
  const { getWeb3, state } = useContext(AppContext);

  const lockNFT = async () => {
    const {
      contracts: {
        staking: { contract },
      },
    } = state;
    if (!state.contracts.nft.data.seletedNFT?.tokenID)
      return toast.error("Please approve an NFT");

    const result = await contract.lockNFT(
      process.env.REACT_APP_CONTRACT_ADDRESS,
      state.contracts.nft.data.seletedNFT.tokenID.toString()
    );

    toast.promise(
      result.wait().then(async () => {
        getWeb3();
      }),
      {
        loading: "Loading...",
        success: "NFT locked",
        error: (error) => error.message,
      }
    );
  };

  const unlockedNFT = async () => {
    const {
      contracts: {
        staking: { contract },
      },
    } = state;

    const result = await contract.unlockNFT(
      process.env.REACT_APP_CONTRACT_ADDRESS
    );
    toast.promise(
      result.wait().then(async () => {
        getWeb3();
      }),
      {
        loading: "Loading...",
        success: "NFT unlocked",
        error: (error) => error.message,
      }
    );
  };

  if (state.contracts.nft.data.lockedNFT?.tokenID) {
    return (
      <button
        onClick={unlockedNFT}
        disabled={
          Date.now() <
          Number(
            state.contracts.nft.data.lockedNFT.unlockDate.toString() * 1000
          )
        }
      >
        Revoke NFT
      </button>
    );
  }

  if (state.contracts.nft.data.seletedNFT) {
    return <button onClick={lockNFT}>Boost Your Staking</button>;
  }

  return (
    <button
      onClick={() => {
        window.open(process.env.REACT_APP_BUY_NFT_LINK, "_blank");
      }}
    >
      Buy NFT
    </button>
  );
};

export default function NFTStatus() {
  const { state, nftItems } = useContext(AppContext);

  return (
    <Style>
      <header>
        <h3>
          {state.contracts.nft.data.lockedNFT?.tokenID
            ? "Your account has the power of"
            : state.contracts.nft.data.seletedNFT
            ? "Your account will have the power of"
            : nftItems.length > 0
            ? "Please pick the NFT you want to use to boost"
            : "Increase your Earning Potential of Staking Rewards"}
        </h3>
        <span className="bonus-amount">
          +{state.contracts.staking.data.boostingPercentage}%
        </span>
      </header>

      <div className="card-custom-body">
        <CardBody />
      </div>
      {(!state.contracts.nft.data.lockedNFT?.tokenID && !state.contracts.nft.data.seletedNFT && nftItems.length > 0)
       && (
        <span className="or">Or</span>
      )}
      <div className="card-custom-footer">
        <ButtonComponent />
      </div>
    </Style>
  );
}
